import type { User } from '@/shared/types';

const STORAGE_KEY = 'current_user';

/** Профиль до ответа сервера: чтобы после перезагрузки имя не мигало заглушкой */
export function readCachedUser(): User | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as User) : null;
  } catch {
    return null;
  }
}

export function writeCachedUser(user: User): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
  } catch {
    // кэш профиля не критичен
  }
}

export function clearCachedUser(): void {
  localStorage.removeItem(STORAGE_KEY);
}
